import React from "react";
import UnderlineSketch from "./UnderlineSketch";

const base = `
  relative group inline-block font-mono border 
  rounded-md overflow-hidden transition-colors duration-300
`;

const defaultStyle = `
  bg-gray-950 text-white text-shadow py-2 px-3
`;

const MonoButton = ({
  type = "button",
  onClick,
  children,
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${base} ${defaultStyle} ${className}`}
    >
      <span className="flex items-center justify-center space-x-2">
        {/* → beim Hover sichtbar */}
        <span className="inline-block transform transition-transform duration-300 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0">
          →
        </span>
        <span className="relative z-10">{children}</span>
      </span>

      {/* Animierte Unterstreichung */}
      <span className="absolute left-0 bottom-0 w-full h-[8px] pointer-events-none">
        <div className="origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-[900ms] ease-out delay-150">
          <UnderlineSketch color="#fff" />
        </div>
      </span>
    </button>
  );
};

export default MonoButton;
